<div class="promotion-code-child-component">
  <h5>Provider Blacklist</h5>
  <div class="promotion-code-child-component-content">
    <ng-container *ngIf="isFreeSpin">

      <div *ngIf="!canEditBlacklist" class="alert alert-warning py-2 px-3 mb-3" style="font-size:13px;">
        View-only — you don't have permission to edit the game provider blacklist.
      </div>

      <!-- Blacklist Preset -->
      <div class="mb-2"><span class="kt-font-bold">Blacklist Preset:</span></div>
      <div class="row mb-3">
        <div class="col-4">
          <div [ngClass]="{ 'disabled-div': presetLocked || !canEditBlacklist || presetLoading }">
            <kt-dropdown-wo-lazyload
              [form]="presetForm"
              [dropdownList]="presetList"
              [dropdownSettings]="presetDropdownSettings"
              [formName]="'preset_id'"
              [selectionAttributes]="'id'"
              [selectedItems]="presetSelectedItems"
              [dataLoading]="presetLoading"
              (selectedItemsChanged)="onPresetSelected($event)">
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
        <div class="col-2">
          <!-- Once a preset is applied the blacklist is locked; use Remove to edit again (matches v1) -->
          <button type="button" class="btn btn-primary w-100" style="background:#0079FE; border-color:#0079FE;"
            (click)="presetLocked ? removePreset() : applyPreset()" [disabled]="!selectedPresetId || !canEditBlacklist">
            {{ presetLocked ? 'Remove' : 'Apply' }}
          </button>
        </div>
      </div>

      <hr>

      <!-- Currency tabs + Apply to other currencies -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center">
          <span class="kt-font-bold mr-3">Currency:</span>
          <button type="button" *ngFor="let c of currencies" class="btn btn-sm mr-2"
                  style="min-width:80px;"
                  [style.background]="activeCurrencyId === c.id ? '#0079FE' : 'transparent'"
                  [style.color]="activeCurrencyId === c.id ? '#fff' : '#0079FE'"
                  [style.border]="activeCurrencyId === c.id ? '1px solid #0079FE' : '1px solid #E4E6EF'"
                  (click)="selectCurrency(c.id)">{{ c.name }}</button>
        </div>
        <a href="javascript:;" (click)="applyToOtherCurrencies()"
           [style.pointer-events]="(presetLocked || !canEditBlacklist) ? 'none' : 'auto'" [style.opacity]="(presetLocked || !canEditBlacklist) ? 0.5 : 1">Apply to other currencies</a>
      </div>

      <div *ngIf="loading" class="text-muted">Loading providers...</div>

      <div class="row" *ngIf="!loading">
        <!-- provider list -->
        <div class="col-4">
          <div class="input-group mb-2">
            <input type="text" class="form-control" placeholder="Search Provider" [(ngModel)]="searchProvider" [ngModelOptions]="{ standalone: true }">
            <div class="input-group-append">
              <span class="input-group-text btn btn-primary"><i class="fa fa-search" style="color:#fff;"></i></span>
            </div>
          </div>
          <ul class="list-unstyled" style="max-height:320px; overflow:auto;">
            <li *ngFor="let p of providersForActiveCurrency()" (click)="selectProvider(p.game_provider_id)"
                class="d-flex justify-content-between align-items-center"
                style="cursor:pointer; padding:6px 4px; border-radius:4px;"
                [style.background]="activeProviderId === p.game_provider_id ? '#F3F6F9' : 'transparent'"
                [style.font-weight]="(activeProviderId === p.game_provider_id || providerHasSelection(p.game_provider_id)) ? '700' : '400'">
              <span>{{ p.game_provider_code }}</span>
              <i *ngIf="providerHasSelection(p.game_provider_id)" class="fas fa-info-circle text-muted"
                 matTooltip="This provider has blacklisted categories in this currency" matTooltipHideDelay="0"></i>
            </li>
            <!-- Empty for two different reasons — tell the operator which one applies. -->
            <li *ngIf="providersForActiveCurrency().length === 0" class="text-muted" style="font-size:12px;">
              <ng-container *ngIf="!hasTargetProvider()">
                <br>No provider to blacklist yet. Go back to <b>Basic Setting</b> and choose a <b>Free Spin Game Provider</b>
              </ng-container>
              <ng-container *ngIf="hasTargetProvider() && searchProvider">
                No provider matches "{{ searchProvider }}".
              </ng-container>
              <ng-container *ngIf="hasTargetProvider() && !searchProvider">
                The selected Free Spin Game Provider has no slots available for this currency. Pick another currency.
              </ng-container>
            </li>
          </ul>

          <!-- Preset Name (Save as Preset button lives in the wizard footer) -->
          <div class="mt-4">
            <div class="mb-1"><span class="kt-font-bold">Preset Name</span></div>
            <input type="text" class="form-control" placeholder="Preset Name" [(ngModel)]="presetName" [ngModelOptions]="{ standalone: true }" [disabled]="!canEditBlacklist">
          </div>
        </div>

        <!-- category / sub-category tree -->
        <div class="col-8">
          <p class="text-muted" style="font-size:12px;">Note: Adding (tick) a category to the blacklist will also include all its sub categories in the blacklist.</p>
          <div *ngFor="let row of categoriesForActive()" class="border rounded mb-2 p-3">
            <label class="kt-font-bold mb-2" style="cursor:pointer;">
              <input type="checkbox" [checked]="isCategoryChecked(row)" (change)="toggleCategory(row)" [disabled]="presetLocked || !canEditBlacklist">
              <span class="pl-2">{{ row.name || row.code }}</span>
            </label>
            <div class="pl-4">
              <label *ngFor="let sub of row.sub_categories" class="d-block mb-1" style="cursor:pointer;">
                <input type="checkbox" [checked]="sub.status === 1" (change)="toggleSubCategory(row, sub)" [disabled]="presetLocked || !canEditBlacklist">
                <span class="pl-2">{{ sub.name }}</span>
              </label>
            </div>
          </div>
          <div *ngIf="categoriesForActive().length === 0" class="text-muted">No categories for this provider.</div>
        </div>
      </div>

      <div *ngIf="feedbackMsg" class="alert alert-info alert-dismissible py-2 px-3 mt-3 mb-0 d-flex justify-content-between align-items-center" style="font-size:13px;">
        <span>{{ feedbackMsg }}</span>
        <button type="button" class="close blacklist-alert-close" aria-label="Close" (click)="feedbackMsg=''" style="position:static; padding:0; line-height:1;"><span aria-hidden="true">&times;</span></button>
      </div>

    </ng-container>
  </div>
</div>
